import {
  BOOKINGS_PAGE_NAME,
  COMPANY_SETTINGS_PAGE_NAME,
  HOMEPAGE_PAGE_NAME,
  LOYALTY_PAGE_NAME,
  TEAM_MANAGEMENT_PAGE_NAME
} from './gtm-page-names'
import { ACCOUNT_CONTEXT } from './gtm4'

export const ALL_ACCOR_BUSINESS_CONTEXT = 'all accor business'

export enum TEAM_MEMBER_INTERACTION {
  INVITE_TEAM_MEMBER = 'invite a team member',
  COPY_INVITATION_LINK = 'copy invitation link',
  SEND_INVITATION = 'send invitation'
}
const AAB_COMPANY_INFO_BLOCK_TYPE = 'company information'

export const AAB_INFO_FIELDS = {
  COMPANY_NAME: 'company name',
  SECTOR_OF_ACTIVITY: 'sector of activity',
  NUMBER_OF_EMPLOYEES: 'number of employees',
  COMPANY_ADDRESS: 'company address'
} as const

type AabInfoFieldsKey = keyof typeof AAB_INFO_FIELDS
export type AabInfoFields = (typeof AAB_INFO_FIELDS)[AabInfoFieldsKey]

export const getAabCompanyInfoFieldAnalyticsProp = (name: AabInfoFields) => ({
  name,
  pageName: COMPANY_SETTINGS_PAGE_NAME,
  blockType: AAB_COMPANY_INFO_BLOCK_TYPE,
  context: ALL_ACCOR_BUSINESS_CONTEXT
})

// PAGE EVENT
export const GTM_AAB_PAGE_DASHBOARD = () => ({
  pageName: HOMEPAGE_PAGE_NAME,
  category: 'loyalty program',
  sub_category_level1: 'all accor business',
  sub_category_level2: 'account',
  sub_category_level3: 'homepage',
  clienttype: 'B2B'
})

export const GTM_AAB_PAGE_LOYALTY = () => ({
  pageName: LOYALTY_PAGE_NAME,
  category: 'loyalty program',
  sub_category_level1: 'all accor business',
  sub_category_level2: 'account',
  sub_category_level3: 'loyalty page',
  clienttype: 'B2B'
})

export const GTM_AAB_PAGE_BOOKINGS = () => ({
  pageName: BOOKINGS_PAGE_NAME,
  category: 'loyalty program',
  sub_category_level1: 'all accor business',
  sub_category_level2: 'account',
  sub_category_level3: 'bookings',
  clienttype: 'B2B'
})

export const GTM_AAB_PAGE_TEAM_MANAGEMENT = () => ({
  pageName: TEAM_MANAGEMENT_PAGE_NAME,
  category: 'loyalty program',
  sub_category_level1: 'all accor business',
  sub_category_level2: 'account',
  sub_category_level3: 'team management',
  clienttype: 'B2B'
})

export const GTM_AAB_PAGE_COMPANY_SETTINGS = () => ({
  pageName: COMPANY_SETTINGS_PAGE_NAME,
  category: 'loyalty program',
  sub_category_level1: 'all accor business',
  sub_category_level2: 'account',
  sub_category_level3: 'company settings',
  clienttype: 'B2B'
})

// BLOC INTERACTION EVENTS

export const GTM_AAB_DASHBOARD_VIEW_DETAILS_LINK = () => ({
  eventName: 'bloc_interact',
  event_data: {
    pagename: HOMEPAGE_PAGE_NAME,
    bloc_name: 'company loyalty benefits',
    bloc_interaction: 'view details',
    context: ALL_ACCOR_BUSINESS_CONTEXT
  }
})

export const GTM_AAB_DASHBOARD_FIND_OUT_MORE_LINK = () => ({
  eventName: 'bloc_interact',
  event_data: {
    pagename: HOMEPAGE_PAGE_NAME,
    bloc_name: 'company loyalty benefits',
    bloc_interaction: 'find out more',
    context: ALL_ACCOR_BUSINESS_CONTEXT
  }
})

export const GTM_AAB_DASHBOARD_VIEW_BOOKINGS_LINK = () => ({
  eventName: 'bloc_interact',
  event_data: {
    pagename: HOMEPAGE_PAGE_NAME,
    bloc_name: 'company bookings',
    bloc_interaction: 'view bookings',
    context: ALL_ACCOR_BUSINESS_CONTEXT
  }
})

export const GTM_AAB_DASHBOARD_VIEW_EMPLOYEES_LINK = () => ({
  eventName: 'bloc_interact',
  event_data: {
    pagename: HOMEPAGE_PAGE_NAME,
    bloc_name: 'team management',
    bloc_interaction: 'view all team members',
    context: ALL_ACCOR_BUSINESS_CONTEXT
  }
})

export const GTM_AAB_DASHBOARD_SEE_COMPANY_INFO_LINK = () => ({
  eventName: 'bloc_interact',
  event_data: {
    pagename: HOMEPAGE_PAGE_NAME,
    bloc_name: 'company information',
    bloc_interaction: 'view company information',
    context: ALL_ACCOR_BUSINESS_CONTEXT
  }
})

export const GTM_AAB_COLLABORATORS_MANAGEMENT_INVITE_TEAM_MEMBER = (
  blocInteraction: TEAM_MEMBER_INTERACTION
) => ({
  eventName: 'bloc_interact',
  event_data: {
    pagename: TEAM_MANAGEMENT_PAGE_NAME,
    bloc_name: 'team members',
    bloc_interaction: blocInteraction,
    context: ALL_ACCOR_BUSINESS_CONTEXT
  }
})

export const GTM_AAB_DASHBOARD_ADD_DOMAIN_NAME = () => ({
  eventName: 'bloc_interact',
  event_data: {
    pagename: TEAM_MANAGEMENT_PAGE_NAME,
    bloc_name: 'domain name',
    bloc_interaction: 'add a domain name',
    context: ALL_ACCOR_BUSINESS_CONTEXT
  }
})

export const GTM_AAB_DASHBOARD_NAV_LINK_ACCOUNT_SWITCHER = ({
  pageName,
  blocInteraction,
  context
}: Record<string, string>) => ({
  eventName: 'bloc_interact',
  event_data: {
    pagename: pageName,
    bloc_name: 'account switcher',
    bloc_interaction: blocInteraction,
    context
  }
})
export const GTM_AAB_COMPANY_TRAVEL_POLICIES_TAB = () => ({
  eventName: 'bloc_interact',
  event_data: {
    pagename: COMPANY_SETTINGS_PAGE_NAME,
    bloc_name: 'company policies',
    bloc_interaction: 'travel policies',
    context: ALL_ACCOR_BUSINESS_CONTEXT
  }
})

export const GTM_AAB_HELP_LINK = (pageName: string) => ({
  eventName: 'bloc_interact',
  event_data: {
    pagename: pageName,
    bloc_name: 'faq',
    bloc_interaction: 'help and support',
    context: ACCOUNT_CONTEXT
  }
})
